import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { UserAuthState } from '@quipo/quipo-lib';
import { SettingService } from 'libs/quipo-lib/src/core/services/settings.service';

@Component({
  selector: 'quipo-stripe-connect-callback',
  templateUrl: './stripe-connect-callback.component.html',
})
export class StripeConnectCallbackComponent implements OnInit {
  status: 'loading' | 'success' | 'error' = 'loading';
  errorMessage = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private settingService: SettingService,
    private store: Store,
  ) {}

  ngOnInit(): void {
    const code = this.route.snapshot.queryParamMap.get('code');
    const state = this.route.snapshot.queryParamMap.get('state');
    const error = this.route.snapshot.queryParamMap.get('error');

    if (error) {
      this.status = 'error';
      this.errorMessage = error;
      return;
    }

    if (!code || !state) {
      this.status = 'error';
      this.errorMessage = 'Missing parameters from Stripe.';
      return;
    }

    const loginInfo = this.store.selectSnapshot(UserAuthState.getUserAuthDetails);
    if (!loginInfo?.token) {
      this.status = 'error';
      this.errorMessage = 'Not authenticated. Please log in and try again.';
      return;
    }

    this.settingService.callStripeConnectCallback(code, state, loginInfo.token).subscribe({
      next: (res: any) => {
        if (res?.success) {
          this.status = 'success';
          setTimeout(() => this.router.navigate(['/clinic/settings']), 2000);
        } else {
          this.status = 'error';
          this.errorMessage = res?.message || 'Connection failed.';
        }
      },
      error: (err) => {
        this.status = 'error';
        this.errorMessage = err?.error?.message || 'Connection failed.';
      },
    });
  }
}
